import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
    Container,
    Row,
    Col,
    // Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"

import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { MultiSelect } from "primereact/multiselect"
import { Checkbox } from "primereact/checkbox"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { updateCompany, createCompany, getLookupsByName, createEntityDocument, getCompany } from "../../helpers/backend-helper";
import { getAuthUser, getAuthToken } from "../../helpers/cookie-utils";
import { getCookie } from "../../helpers/cookie";
import axios from "axios";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable"
import { Column } from "jspdf-autotable"
import { set } from "lodash"
// Create axios instance for direct API calls
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";
const backendApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
backendApi.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Handle FormData - remove Content-Type to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);
//i18n

const CompanyEditForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const companyData = location.state?.companyData;
    const fileUploadRef = useRef(null)
    const Editid = companyData?.id;
    console.log(companyData, 'companyData');
    
    const token = getCookie('access_token');
    const [company, setCompany] = useState(companyData?.name || "");
    const [companyCode, setCompanyCode] = useState(companyData?.company_code || "");
    const [website, setWebsite] = useState(companyData?.website || "");
    const [email, setEmail] = useState(companyData?.email || "");
    const [phno, setPhno] = useState(companyData?.phone || "");
    const [yearFounded, setYearFounded] = useState(companyData?.year_founded || "");
    const [specialties, setSpecialties] = useState(companyData?.specialties || "");
    const [lastSelectedIndustryId, setLastSelectedIndustryId] = useState(null)
    const [statusModalVisible, setStatusModalVisible] = useState(false)
    const [editingStatus, setEditingStatus] = useState(false)
    const [statusForm, setStatusForm] = useState('')
    const [statusDescription, setStatusDescription] = useState('')
    const [industry, setIndustry] = useState()
    const [createdBy, setCreatedBy] = useState(companyData?.created_by_name || "")
    const [editedBy, setEditedBy] = useState(companyData?.updated_by_name || "")
    const createdAt = companyData?.created_at || ""
    const editedAt = companyData?.updated_at || ""
    const [companySize, setCompanySize] = useState('')
    const [selectedGroup1, setSelectedGroup1] = useState();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [subject, setSubject] = useState('');
    const [displayDialog, setDisplayDialog] = useState(false);
    const [selectedCategory1, setSelectedCategory1] = useState();
    const [privateDrop, setPrivateDrop] = useState(companyData?.is_private);
    const [address, setAddress] = useState('');
    useEffect(() => {
        if (companyData) {
            setTimeout(() => {
                setIndustry(companyData?.industry || companyData?.industry_name)
                setCompanySize(companyData?.company_size)
                setSelectedGroup1(companyData?.groups[0])
                setSelectedCategory1(companyData?.categories[0])
                setAddress(companyData?.address ? companyData.address.replace(/,/g, '\n') : "")
            },1000)
        }
    }, [companyData])
 useEffect(() => {
    try {
      if (!industry) return;
      if (industry.id === 'add' || industry === 'add') {
        setStatusForm('')
        setStatusDescription('')
        setStatusModalVisible(true)
        // setIndustry(null)
      } else if (industry.id === 'edit' || industry === 'edit') {
          setEditingStatus(true)
          try {
            const pool = dynamicIndustries.length ? dynamicIndustries : industries
            const match = pool.find(o => String(o.id) === String(lastSelectedIndustryId))
            if (match) setStatusForm(match.name || match.value || '')
            if (match) setStatusDescription((match.raw && (match.raw.description || match.raw.desc)) || match.description || '')
          } catch (err) { console.error('prefill industry failed', err) }
          setStatusModalVisible(true)
          setIndustry(lastSelectedIndustryId)
      } else {
        const idToSet = industry && (industry.id ?? industry);
        setLastSelectedIndustryId(idToSet)
        // setSelectedEditdrop(idToSet)
      }
    } catch (err) {
      console.error('Industry selection watcher error', err)
    }
  }, [industry])
    const industries = [
        { name: "Information Technology", code: "IT" },
        { name: "Healthcare", code: "HC" },
        { name: "Finance", code: "FN" },
        { name: "Manufacturing", code: "MN" },
        { name: "Retail", code: "RT" },
        // Add more industries here
    ]

    

    const companySizes = [
        { name: "1-10 employees", code: "1-10" },
        { name: "11-50 employees", code: "11-50" },
        { name: "51-200 employees", code: "51-200" },
        { name: "201-500 employees", code: "201-500" },
        { name: "501-1000 employees", code: "501-1000" },
        { name: "1001-5000 employees", code: "1001-5000" },
        { name: "5001+ employees", code: "5001+" },
    ]

    const [overview1, setOverview1] = useState(
        companyData?.overview || companyData?.description || ""
    );


    const categoryOptions = [
        { label: "Micro Enterprise", value: "micro" },
        { label: "Small Enterprise", value: "small" },
        { label: "Medium Enterprise", value: "medium" },
        { label: "Large Enterprise", value: "large" },
    ];


    const groupOptions = [
        { label: "Up to 5 Crore", value: "5cr" },
        { label: "Up to 50 Crore", value: "50cr" },
        { label: "Up to 250 Crore", value: "250cr" },
        { label: "Above 250 Crore", value: "above250cr" },
    ];

    const [userid1, setUserid1] = useState("Harish");

    const onUpload = (event) => {
        // Store uploaded files for later processing
        setUploadedFiles(event.files);
        console.log('Files uploaded and stored:', event.files);
        console.log('File details:', event.files.map(f => ({ 
            name: f.name, 
            size: f.size, 
            type: f.type, 
            lastModified: f.lastModified 
        })));
        toast.current.show({ 
            severity: 'info', 
            summary: 'Success', 
            detail: `${event.files.length} file(s) selected for upload` 
        });
    };

    // File select handler - stores files when they're selected
    const onFileSelect = (event) => {
        const files = event.files;
        setUploadedFiles(files);
        console.log('Files selected:', files);
        console.log('Files stored in state:', files.map(f => ({ 
            name: f.name, 
            size: f.size, 
            type: f.type 
        })));
        console.log('Current uploadedFiles state will be:', files);
    };

    const labels = [
        { name: "Work from Office (WFO)", code: "WORK" },
        { name: "Work from Home (WFH)", code: "HOME" },
        { name: "Work from Remote (WFR)", code: "REMOTE" }
    ]

    const [visible, setVisible] = useState(false)
    const [street1, setStreet1] = useState(() => companyData?.street1 || "")
    const [street2, setStreet2] = useState(() => companyData?.street2 || "")
    const [selectedCity, setSelectedCity] = useState(() => {
        const c = companyData?.city;
        if (!c) return "";
        // if it's a plain string, wrap into object with name
        return typeof c === 'string' ? { name: c, code: c } : c;
    })
    const addCities = [
        { name: 'Hyderabad', code: 'HYD' },
        { name: 'Chennai', code: 'CHN' },
        { name: 'Mumbai', code: 'MUM' },
        { name: 'Bangalore', code: 'BLR' },
        { name: 'Delhi', code: 'DEL' },
    ]
    const [selectedState, setSelectedState] = useState(() => {
        const s = companyData?.state;
        if (!s) return "";
        return typeof s === 'string' ? { name: s, code: s } : s;
    })
    const addStates = [
        { name: 'Andhra Pradesh', code: 'AP' },
        { name: 'Telangana', code: 'TG' },
        { name: 'Tamil Nadu', code: 'TN' },
        { name: 'Karnataka', code: 'KA' },
        { name: 'Kerala', code: 'KL' },
    ]
    const [selectedCountry, setSelectedCountry] = useState(() => {
        const c = companyData?.country;
        if (!c) return "";
        return typeof c === 'string' ? { name: c, code: c } : c;
    })
    const addCountries = [
        { name: "India", code: "IN" },
        { name: "United States", code: "US" },
        { name: "Canada", code: "CA" },
        { name: "Germany", code: "DE" },
        { name: "Australia", code: "AU" },
    ]

    const [postalCode, setPostalCode] = useState(companyData?.postal_code || "")
    const [selectedLabel, setSelectedLabel] = useState()

   

    // Social pages state variables
    const [linkedinUrl, setLinkedinUrl] = useState(companyData?.linkedin_url || "");
    const [facebookUrl, setFacebookUrl] = useState(companyData?.facebook_url || "");
    const [twitterUrl, setTwitterUrl] = useState(companyData?.twitter_url || "");
    const [indeedUrl, setIndeedUrl] = useState(companyData?.indeed_url || "");

    const updateAddress = () => {
        // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
    }
    useEffect(() => {
        // Normalize selected objects to their display names when present
        const cityName = selectedCity && typeof selectedCity === 'object' ? selectedCity.name || '' : selectedCity;
        const stateName = selectedState && typeof selectedState === 'object' ? selectedState.name || '' : selectedState;
        const countryName = selectedCountry && typeof selectedCountry === 'object' ? selectedCountry.name || '' : selectedCountry;
        const labelName = selectedLabel && typeof selectedLabel === 'object' ? selectedLabel.name || '' : selectedLabel;

        const addressComponents = [
            street1,
            street2,
            cityName,
            stateName,
            countryName,
            postalCode,
            labelName,
        ];

        const filteredComponents = addressComponents.filter(Boolean);
        const updatedAddress = filteredComponents.join('\n '); // Convert array to comma-separated string

        console.log('Address composition:', {
            raw: { selectedCity, selectedState, selectedCountry, selectedLabel },
            components: addressComponents,
            filtered: filteredComponents,
            finalAddress: updatedAddress
        });

        setAddress(updatedAddress)
    }, [
        street1,
        street2,
        postalCode,
        selectedState,
        selectedCity,
        selectedCountry,
        selectedLabel,
    ])
    

    // Private state variables
    const [PrivetDropdown, setPrivetDropdown] = useState([])
    console.log(PrivetDropdown, 'PrivetDropdown');
    const [PrivetDropdownValues, setPrivetDropdownValues] = useState(null)
    
    // Get private users for dropdown
    const getPrivateOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data) {
                let results = response.data.data;
                console.log(results, 'results');
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                    email: category.email,
                }));
                setPrivetDropdownValues(options);
            }
        } catch (error) {
            // Fallback in case of error
            console.error('Error fetching private users:', error);
        }
    };

    // company edit form ends

    // Dynamic data loading and form submission logic
    const [dynamicIndustries, setDynamicIndustries] = useState([]);
    const [dynamicCompanySizes, setDynamicCompanySizes] = useState([]);
    const [dynamicCategories, setDynamicCategories] = useState([]);
    const [dynamicGroups, setDynamicGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // File upload state
    const [uploadedFiles, setUploadedFiles] = useState([]);

    // Helper functions to get display names from IDs
    const getIndustryDisplayName = () => {
        if (!companyData?.industry) return "Technology";
        
        // First check if dynamic data is loaded
        if (dynamicIndustries.length > 0) {
            const found = dynamicIndustries.find(i => 
                String(i.id) === String(companyData.industry) || 
                String(i.value) === String(companyData.industry) || 
                String(i.name) === String(companyData.industry)
            );
            if (found) return found.name;
        }
        
        // Fallback to static industries
        const staticFound = industries.find(i => 
            i.code === companyData.industry || 
            i.name === companyData.industry
        );
        return staticFound ? staticFound.name : companyData.industry;
    };

    const getCompanySizeDisplayName = () => {
        if (!companyData?.company_size) return "100 employees";
        
        // First check if dynamic data is loaded
        if (dynamicCompanySizes.length > 0) {
            const found = dynamicCompanySizes.find(s => 
                String(s.id) === String(companyData.company_size) || 
                String(s.value) === String(companyData.company_size) || 
                String(s.name) === String(companyData.company_size)
            );
            if (found) return found.name;
        }
        
        // Fallback to static company sizes
        const staticFound = companySizes.find(s => 
            s.code === companyData.company_size || 
            s.name === companyData.company_size
        );
        return staticFound ? staticFound.name : companyData.company_size;
    };

    const getCategoryDisplayName = () => {
        if (!companyData?.categories) return "Large Enterprise";
        
        const categoryValue = Array.isArray(companyData.categories) ? companyData.categories[0] : companyData.categories;
        
        // First check if dynamic data is loaded
        if (dynamicCategories.length > 0) {
            const found = dynamicCategories.find(c => 
                String(c.id) === String(categoryValue) || 
                String(c.value) === String(categoryValue) || 
                String(c.label) === String(categoryValue)
            );
            if (found) return found.label;
        }
        
        // Fallback to static categories
        const staticFound = categoryOptions.find(c => 
            c.value === categoryValue || 
            c.label === categoryValue
        );
        return staticFound ? staticFound.label : categoryValue;
    };

    const getGroupDisplayName = () => {
        if (!companyData?.groups) return "Above 250 Crore";
        
        const groupValue = Array.isArray(companyData.groups) ? companyData.groups[0] : companyData.groups;
        
        // First check if dynamic data is loaded
        if (dynamicGroups.length > 0) {
            const found = dynamicGroups.find(g => 
                String(g.id) === String(groupValue) || 
                String(g.value) === String(groupValue) || 
                String(g.label) === String(groupValue)
            );
            if (found) return found.label;
        }
        
        // Fallback to static groups
        const staticFound = groupOptions.find(g => 
            g.value === groupValue || 
            g.label === groupValue
        );
        return staticFound ? staticFound.label : groupValue;
    };

   
        const normalizeArrayFromResponse = (resp) => {
            if (!resp) return [];
            // Handle common shapes: resp.results, resp.data.results, resp.results.results
            if (Array.isArray(resp)) return resp;
            if (Array.isArray(resp.results)) return resp.results;
            if (resp.results && Array.isArray(resp.results.results)) return resp.results.results;
            if (resp.data && Array.isArray(resp.data.results)) return resp.data.results;
            if (resp.data && Array.isArray(resp.data)) return resp.data;
            return [];
        };

 const loadDropdownData = async () => {
            try {
                // industries (try both common lookup names)
                let industriesResp = await getLookupsByName('company_industry').catch(() => null);
                if (!industriesResp) industriesResp = await getLookupsByName('industries').catch(() => null);
                const rawIndustries = normalizeArrayFromResponse(industriesResp) || [];
                const normalizedIndustries = rawIndustries.map(item => ({ id: item.id, name: item.value || item.name || String(item.id), value: item.value || item.name || item.id, raw: item }));
                setDynamicIndustries(normalizedIndustries);
                console.log('Fetched industries:', normalizedIndustries);
                
                // company sizes
                let sizesResp = await getLookupsByName('company_size').catch(() => null);
                if (!sizesResp) sizesResp = await getLookupsByName('company_sizes').catch(() => null);
                const rawSizes = normalizeArrayFromResponse(sizesResp) || [];
                const normalizedSizes = rawSizes.map(item => ({ id: item.id, name: item.value || item.name || String(item.id), value: item.value || item.name || item.id, raw: item }));
                setDynamicCompanySizes(normalizedSizes);

                // categories
                let categoriesResp = await getLookupsByName('company_categories').catch(() => null);
                if (!categoriesResp) categoriesResp = await getLookupsByName('categories').catch(() => null);
                const rawCategories = normalizeArrayFromResponse(categoriesResp) || [];
                const normalizedCategories = rawCategories.map(item => ({ label: item.value || item.name || String(item.id), value: item.id ?? item.value ?? item.name, id: item.id, raw: item }));
                setDynamicCategories(normalizedCategories);

                // groups
                let groupsResp = await getLookupsByName('company_group').catch(() => null);
                if (!groupsResp) groupsResp = await getLookupsByName('groups').catch(() => null);
                const rawGroups = normalizeArrayFromResponse(groupsResp) || [];
                const normalizedGroups = rawGroups.map(item => ({ label: item.value || item.name || String(item.id), value: item.id ?? item.value ?? item.name, id: item.id, raw: item }));
                setDynamicGroups(normalizedGroups);

                console.log('Normalized industries:', normalizedIndustries);
                console.log('Normalized company sizes:', normalizedSizes);
                console.log('Normalized categories:', normalizedCategories);
                console.log('Normalized groups:', normalizedGroups);

                // Load private users for dropdown
                await getPrivateOptions();

                // Handle existing private users if editing a company
                if (companyData && companyData.private_users && Array.isArray(companyData.private_users)) {
                    console.log('Setting private users from company data:', companyData.private_users);
                    // setPrivateDrop(true);
                    // Note: We'll need to wait for PrivetDropdownValues to be populated by getPrivateOptions
                    // This will be handled in a separate useEffect
                }

                // After loading lookups, set initial selections when editing existing company
                if (companyData) {
                    // Industry
                    try {
                        const foundInd = normalizedIndustries.find(i => String(i.id) === String(companyData.industry) || String(i.value) === String(companyData.industry) || String(i.name) === String(companyData.industry));
                        // if (foundInd) setIndustry(foundInd);
                    } catch (e) { /* ignore */ }

                    // Company Size
                    try {
                        const foundSize = normalizedSizes.find(s => String(s.id) === String(companyData.company_size) || String(s.value) === String(companyData.company_size) || String(s.name) === String(companyData.company_size));
                        // if (foundSize) setCompanySize(foundSize);
                    } catch (e) { /* ignore */ }

                    // Categories (pick first)
                    try {
                        const catVal = Array.isArray(companyData.categories) ? companyData.categories[0] : companyData.categories;
                        if (catVal !== undefined && catVal !== null) {
                            const foundCat = normalizedCategories.find(c => String(c.id) === String(catVal) || String(c.value) === String(catVal) || String(c.label) === String(catVal));
                            // if (foundCat) setSelectedCategory1(foundCat);
                        }
                    } catch (e) { /* ignore */ }

                    // Groups (pick first)
                    try {
                        const grpVal = Array.isArray(companyData.groups) ? companyData.groups[0] : companyData.groups;
                        if (grpVal !== undefined && grpVal !== null) {
                            const foundGrp = normalizedGroups.find(g => String(g.id) === String(grpVal) || String(g.value) === String(grpVal) || String(g.label) === String(grpVal));
                            // if (foundGrp) setSelectedGroup1(foundGrp);
                        }
                    } catch (e) { /* ignore */ }
                }
            } catch (error) {
                console.error('Error loading dropdown data:', error);
            }
        };
useEffect(() => {
    loadDropdownData();
}
, [companyData]);
    // Handle existing private users when PrivetDropdownValues is populated
    useEffect(() => {
        if (companyData && companyData.private_users && Array.isArray(companyData.private_users) && 
            PrivetDropdownValues && Array.isArray(PrivetDropdownValues)) {
            console.log('Populating private users from company data:', companyData.private_users);
            console.log('Available private users options:', PrivetDropdownValues);
            
            // Find matching users in PrivetDropdownValues
            const selectedPrivateUsers = [];
            companyData.private_users.forEach(userId => {
                const foundUser = PrivetDropdownValues.find(option => 
                    String(option.code) === String(userId) || String(option.id) === String(userId)
                );
                if (foundUser) {
                    selectedPrivateUsers.push(foundUser);
                }
            });
            
            console.log('Matched private users:', selectedPrivateUsers);
            setPrivetDropdown(selectedPrivateUsers);
            if (selectedPrivateUsers.length > 0) {
                // setPrivateDrop(true);
            }
        }
    }, [PrivetDropdownValues, companyData?.private_users]);

    // Debug: Log current state values when they change
    useEffect(() => {
        console.log("Form state values:", {
            company,
            companyCode,
            website,
            email,
            phno,
            yearFounded,
            specialties,
            overview1,
            industry,
            companySize,
            selectedCategory1,
            selectedGroup1,
            address,
            addressFields: {
                street1,
                street2,
                selectedCity,
                selectedState,
                selectedCountry,
                postalCode
            },
            linkedinUrl,
            facebookUrl,
            twitterUrl,
            indeedUrl
        });
    }, [company, companyCode, website, email, phno, yearFounded, specialties, overview1, industry, companySize, selectedCategory1, selectedGroup1, address, street1, street2, selectedCity, selectedState, selectedCountry, postalCode, linkedinUrl, facebookUrl, twitterUrl, indeedUrl]);

    // Handle form submission
    const handleUpdateCompany = async () => {
        // Basic validation
        if (!company.trim()) {
            toast.current.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Company name is required.',
                life: 3000
            });
            return;
        }

        if (!email.trim()) {
            toast.current.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Email is required.',
                life: 3000
            });
            return;
        }

        if (!companyCode.trim()) {
            toast.current.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Company code is required.',
                life: 3000
            });
            return;
        }

        setIsLoading(true);
        try {
            // Get current user information for tenant
            const currentUser = getAuthUser();
            const currentTenant = currentUser?.tenant || companyData?.tenant || 1;
            
            // Check for different possible ID field names
            const companyId = companyData?.id || companyData?.pk || companyData?.company_id;

            console.log('Current authenticated user:', currentUser);
            console.log('Current tenant ID:', currentTenant);

            // Documents will be uploaded AFTER company creation/update
            let uploadedDocumentIds = [];

            const toPk = (v) => {
                if (v === undefined || v === null) return null;
                if (typeof v === 'number') return v;
                if (typeof v === 'string') {
                    // numeric string -> number, else null
                    const n = Number(v);
                    return Number.isFinite(n) ? n : null;
                }
                if (typeof v === 'object') {
                    if (v.id !== undefined) return toPk(v.id);
                    if (v.value !== undefined) return toPk(v.value);
                }
                return null;
            };

            // Try resolving PKs using loaded lookup arrays when direct conversion fails
            const resolvePk = (val, list) => {
                const direct = toPk(val);
                if (direct) return direct;
                try {
                    if (Array.isArray(list) && list.length) {
                        const found = list.find(it =>
                            String(it.id) === String(val) ||
                            String(it.value) === String(val) ||
                            String(it.name) === String(val) ||
                            String(it.label) === String(val)
                        );
                        if (found) return toPk(found.id ?? found.value ?? found);
                    }
                } catch (e) { /* ignore */ }
                return null;
            };

            const resolvedIndustry = resolvePk(industry, dynamicIndustries);
            const resolvedCompanySize = resolvePk(companySize, dynamicCompanySizes);
            const resolvedCategory = selectedCategory1 ? resolvePk(selectedCategory1.id ?? selectedCategory1.value ?? selectedCategory1, dynamicCategories) : null;
            const resolvedGroup = selectedGroup1 ? resolvePk(selectedGroup1.id ?? selectedGroup1.value ?? selectedGroup1, dynamicGroups) : null;

            console.log('Resolved PKs:', { resolvedIndustry, resolvedCompanySize, resolvedCategory, resolvedGroup });

            const formData = {
                name: company,
                website: website,
                email: email,
                phone: phno,
                year_founded: yearFounded ? parseInt(yearFounded) : null,
                specialties: specialties,
                // send numeric PKs where available (backend expects pk/int)
                industry: resolvedIndustry,
                company_size: resolvedCompanySize,
                overview: overview1,
                categories: selectedCategory1 ? [resolvedCategory] : [],
                groups: selectedGroup1 ? [resolvedGroup] : [],
                address: typeof address === 'string' ? address : (address.join ? address.join(', ') : ""),
                // Individual address fields
                street1: street1,
                street2: street2,
                city: selectedCity,
                state: selectedState,
                country: selectedCountry,
                postal_code: postalCode,
                // Add required fields
                company_code: companyCode || (companyId ? companyData?.name?.toUpperCase().replace(/\s+/g, '_') : `COMP${Date.now()}`), // Use form input, or generate from name for updates, or timestamp for new
                tenant: currentTenant, // Use current user's tenant or existing or default to 1
                // Social media URLs
                linkedin_url: linkedinUrl,
                facebook_url: facebookUrl,
                twitter_url: twitterUrl,
                indeed_url: indeedUrl,
                // Private users - only include if privateDrop is checked and there are valid users
                // ...(privateDrop && PrivetDropdown && PrivetDropdown.length > 0 && {
                //     private_users: PrivetDropdown.filter(user => user && user.code).map(user => user.code)
                // }),
                is_private: privateDrop,
                private_users: privateDrop ? PrivetDropdown.filter(user => user && user.code).map(user => user.code) : [],
                // Documents will be uploaded separately after company creation/update
            };

            console.log('=== FORM SUBMISSION DEBUG ===');
            console.log('Files in uploadedFiles state:', uploadedFiles);
            console.log('Number of files to upload:', uploadedFiles?.length || 0);
            console.log('📄 DOCUMENT IDs BEING INCLUDED IN COMPANY PAYLOAD:', uploadedDocumentIds);
            console.log('Files details:', uploadedFiles?.map(f => ({ 
                name: f.name, 
                size: f.size, 
                type: f.type 
            })) || []);
            
            console.log('🎉 COMPANY PAYLOAD WITH DOCUMENT IDs:', JSON.parse(JSON.stringify(formData)));
            console.log('✅ Documents array in payload:', formData.documents);
            console.log('Categories array:', formData.categories);
            console.log('Groups array:', formData.groups);
            console.log('Company code:', formData.company_code);
            console.log('Tenant:', formData.tenant);
            console.log('Address fields:', {
                address: formData.address,
                street1: formData.street1,
                street2: formData.street2,
                city: formData.city,
                state: formData.state,
                country: formData.country,
                postal_code: formData.postal_code
            });
            console.log('Social media URLs:', {
                linkedin_url: formData.linkedin_url,
                facebook_url: formData.facebook_url,
                twitter_url: formData.twitter_url,
                indeed_url: formData.indeed_url
            });
            console.log('Company ID for update:', companyData?.id);
            console.log('Company pk (alternative ID):', companyData?.pk);
            console.log('Company company_id (alternative ID):', companyData?.company_id);
            console.log('Is this an update operation?', !!(companyData?.id || companyData?.pk || companyData?.company_id));
            
            console.log('NOTE: Documents will be uploaded separately AFTER company creation/update');
            console.log('================================');

            let response;
            let successMessage;

            if (companyId) {
                // Update existing company
                console.log('Calling updateCompany with ID:', companyId);
                response = await updateCompany(companyId, formData);
                successMessage = `Company "${company}" has been updated successfully!`;
                console.log('Update response:', response);
            } else {
                // Create new company
                console.log('Creating new company (no ID found)');
                response = await createCompany(formData);
                successMessage = `Company "${company}" has been created successfully!`;
                console.log('Create response:', response);
            }

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: successMessage,
                life: 3000
            });

            // Get the company ID from response or existing company data
            const finalCompanyId = companyId || response?.data?.id || response?.id;
            
            // STEP 2: Upload documents AFTER company creation/update (if any files are selected)
            if (uploadedFiles && uploadedFiles.length > 0 && finalCompanyId) {
                console.log('� UPLOADING DOCUMENTS AFTER COMPANY OPERATION');
                console.log('Files to upload:', uploadedFiles.length);
                console.log('Company ID:', finalCompanyId);
                
                try {
                    for (const file of uploadedFiles) {
                        console.log('--- Uploading file after company operation ---');
                        console.log('File:', { 
                            name: file.name, 
                            size: file.size, 
                            type: file.type 
                        });
                        
                        const documentFormData = new FormData();
                        documentFormData.append('file', file);
                        documentFormData.append('name', file.name);
                        documentFormData.append('description', `Document for company ${company}`);
                        documentFormData.append('tenant', currentTenant);
                        
                        // Upload to company-specific document endpoint
                        console.log('Uploading to company-specific document endpoint...');
                        const uploadResult = await createEntityDocument('companies', finalCompanyId, documentFormData);
                        
                        console.log('✅ Document uploaded successfully:', uploadResult);
                        
                        // Store the document ID
                        uploadedDocumentIds.push(uploadResult.id);
                    }
                    
                    console.log('🎉 All documents uploaded! Document IDs:', uploadedDocumentIds);
                    
                    toast.current.show({
                        severity: 'success',
                        summary: 'Documents Uploaded',
                        detail: `${uploadedDocumentIds.length} document(s) uploaded successfully!`,
                        life: 3000
                    });
                    
                } catch (documentError) {
                    console.error('❌ Error uploading documents after company operation:', documentError);
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Document Upload Error',
                        detail: 'Company saved successfully, but some documents failed to upload. You can add them later.',
                        life: 5000
                    });
                }
            }

            console.log('✅ SUCCESS! Company operation completed!');
            if (uploadedDocumentIds.length > 0) {
                console.log('📄 Documents were uploaded AFTER company operation');
                console.log('📄 Document IDs:', uploadedDocumentIds);
            }

            // Navigate back to companies list after successful operation
            setTimeout(() => {
                navigate('/companies-allactive');
            }, 2000);

        } catch (error) {
            console.error('Error with company operation:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || `Failed to ${companyData?.id ? 'update' : 'create'} company. Please try again.`,
                life: 5000
            });
        } finally {
            setIsLoading(false);
        }
    };

    // toast msg

    const toast = useRef(null);

    const showMessage = () => {
        toast.current.show({ severity: 'info', summary: 'Job ID 3048 Saved' });
    };
    const showCancel = () => {
        toast.current.show({ severity: 'error', summary: 'Cancelled', life: 3000 });
    }

const handleLookupSave = async () => {
  try {
    if (statusForm?.trim() === "") {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Value cannot be empty",
      });
      return;
    }

    const body = {
      name: "company_industry",
      value: statusForm,
      description: statusDescription || statusForm,
      type: "company",
    };
      const token = getCookie("access_token") || getCookie("authToken");

    if (editingStatus && lastSelectedIndustryId) {
      await axios.patch(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedIndustryId}/`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } else {
      await axios.post(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }

    // reset state
    setStatusModalVisible(false);
    setEditingStatus(false);
    setStatusForm("");
    setStatusDescription("");

    // refresh industry list
    await loadDropdownData();
  } catch (err) {
    console.error("Failed saving company_industry lookup", err);
  }
};
const [documents, setDocuments] = useState();
    const getDocuments =async (id)=>
    {
      try
      {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/companies/${Editid}/documents/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          console.log(response, 'responseiojiodjio');
          const apiData = response.data.data;
  setDocuments(apiData);
        }
      }catch(err) 
      {
        console.log(err);
        
      }
    }
const [documentTypes, setdocumentTypes] = useState([]);
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumentTypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        getDoctType();
        getDocuments();
    }, []);
const handleAddDocument = async () => {
        try {
            const formData = new FormData();
            formData.append('type', selectedDocument || '');
            formData.append('description', subject || '');
            if (uploadedFiles instanceof File) {
                formData.append('file', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('file', file); 
                });
            }

            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/companies/${Editid}/documents/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );


            if (response.status === 201) {
                console.log('Document added successfully:', response.data);
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setFile(null);
                getDocuments();
                setUploadedFiles([]);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document added successfully', life: 3000 });
            }
        } catch (error) {
            console.error('Error adding document:', error);
        }
    };
const [FileNames,setFileNames] = useState([]);
    const [isEdit,setIsEdit]= useState(false);
    const [selectedDocId,setSelectedDocId]= useState(null);
    const handleEdit = (doc) => {
        console.log('Editing document:', doc);
        setDisplayDialog(true);
        setSelectedDocId(doc.id);
        setIsEdit(true);
        setSubject(doc.description);
        setSelectedDocument(doc.type || null);
        const LastFiles = Array.isArray(doc.files)
            ? doc.files.map((fileItem, index) => ({
                id: `${doc.id}-${index}`,
                selectedId: fileItem.id,
                name: fileItem.original_filename,
                url: fileItem.file, 
            }))
            : doc.files
                ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
                : [];

        setFileNames(LastFiles);
    };
    
    const handleDelete = async (rowKey) => {
        console.log('Deleting document with key:', rowKey);
        
        try {
            const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/companies/${Editid}/documents/${rowKey}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                getDocuments()
                toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
            }
        } catch (err) {
            console.log(err);

        }
    }
    const handleUpdateDocument = async () => {
    if (!selectedDocument || !subject) {
        alert('Please fill all the fields.');
        return;
    }

    try {
        const formData = new FormData();

        // Document type
        const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
        const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
        formData.append('type', selectedDocument);
        formData.append('description', subject);

        // Append newly uploaded files
        if (uploadedFiles && uploadedFiles.length > 0) {
            uploadedFiles.forEach((file) => {
                formData.append('uploaded_files', file);
            });
        }
        if (FileNames && FileNames.length > 0) {
            FileNames.forEach((file) => {
                formData.append('files_to_keep', file.selectedId);
            });
        }

        const response = await axios.patch(
            `${process.env.REACT_APP_Company_Contact}/company/companies/${Editid}/documents/${selectedDocId}/`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        if (response.status == 200 || response.status == 201) {
        getDocuments();
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setFileNames([]);
        setUploadedFiles([]);
        setIsEdit(false);
        }

        toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });

    } catch (err) {
        console.error('Failed to update document', err);
        alert('Failed to update document');
    }
};
    return (
        <React.Fragment>
            <div className="page-content create-ajob">
                <Container fluid>
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="page-title">
                                    {companyData ? 'Edit Company' : 'Create a Company'}
                                </h1>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item active">
                                        {companyData 
                                            ? `Edit details for ${companyData.name || 'this company'}`
                                            : 'Create a company with essential details, including company information and company details, to maintain accurate records and streamline business operations.'
                                        }
                                    </li>
                                </ol>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <Toast ref={toast} />
                                    {/* <Link to="/">
                                    </Link> */}
                                    <button 
                                        type="button" 
                                        className="btn btn-success me-2" 
                                        onClick={handleUpdateCompany}
                                        disabled={isLoading}
                                    >
                                        <i className="pi pi-save me-1"></i> 
                                        {isLoading ? 'Saving...' : (companyData ? 'Update' : 'Save')}
                                    </button>

                                    <Link to="/companies-allactive">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row>
                        {/* 1st Row */}
                        <Col xl={6}>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Basic Information</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Company</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText 
                                                            id="company" 
                                                            value={company} 
                                                            onChange={(e) => setCompany(e.target.value)}
                                                            className="w-full" 
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="companyCode">Company Code</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText 
                                                            id="companyCode" 
                                                            value={companyCode} 
                                                            onChange={(e) => setCompanyCode(e.target.value)}
                                                            className="w-full" 
                                                            placeholder="Enter company code"
                                                            readOnly
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label
                                                            htmlFor="website"
                                                            className=" block mb-2"
                                                        >
                                                            Website
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="website"
                                                            className="w-full"
                                                            value={website}
                                                            onChange={(e) => setWebsite(e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="email">Email</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="p-field mb-0">
                                                            <InputText
                                                                id="email"
                                                                className="w-full"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="currentSalary" className="block mb-2">
                                                            Phone Number
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="phone"
                                                            className="w-full"
                                                            value={phno}
                                                            onChange={(e) => setPhno(e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="yearFounded" className="block mb-2">
                                                            Year Founded
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>

                                                        <InputText
                                                            id="yearFounded"
                                                            value={yearFounded}
                                                            onChange={(e) => setYearFounded(e.target.value)}
                                                            className="w-full"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="specialities" className="block mb-2">
                                                            Specialties
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>

                                                        <InputText
                                                            id="specialities"
                                                            value={specialties}
                                                            onChange={(e) => setSpecialties(e.target.value)}
                                                            className="w-full"
                                                        />
                                                    </Col>
                                                </Row>

                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                             <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">System Fields</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">
                                                <Row>
                                                    <Col xl={12}>
                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    Created Date
                                                                </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <Calendar
                                                                    id="createDate"
                                                                    placeholder="27/02/2025"
                                                                    className="w-full"
                                                                    disabled
                                                                    value={createdAt ? new Date(createdAt) : null}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    Edit Date
                                                                </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <Calendar
                                                                    id="editDate"
                                                                    disabled
                                                                    className="w-full"
                                                                    placeholder="Edited Date"
                                                                    value={editedAt ? new Date(editedAt) : null}
                                                                    readOnly
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    Created By
                                                                </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="integer"
                                                                    className="w-full"
                                                                    disabled
                                                                    value={createdBy}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    Edited By
                                                                </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="integer"
                                                                    className="w-full"
                                                                    placeholder=""
                                                                    value={editedBy}
                                                                    disabled
                                                                />
                                                            </Col>
                                                        </Row>

                                                        


                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Documents</h4>

                                    <Row>
                                        <Col xl={12}>
                                        <div className="d-flex justify-content-end mb-3 mt-1">
                                                    <Button
                                                        color="primary"
                                                        onClick={() => setDisplayDialog(true)}
                                                    >
                                                        <i className="pi pi-plus me-1"></i> Add More
                                                    </Button>
                                                </div>
                                            <div>
                                                <DataTable
                                                    value={documents}
                                                    rows={5}
                                                    className="p-datatable-gridlines"
                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                >
                                                    <Column
                                                        field="type_name"
                                                        header="Document Type"
                                                    />
                                                    <Column
                                                        field="description"
                                                        header="Subject"
                                                    />
                                                    <Column
                                                        field="created_at"
                                                        header="Uploaded On"
                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                    />
                                                    <Column
                                                        header="Attachments"
                                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                                            <ul className="list-unstyled mb-0">
                                                                {rowData.files.map((fileItem) => (
                                                                    <li key={fileItem.id}>
                                                                        <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                                            {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : 'No file'}
                                                    />
                                                    <Column
                                                        header="Actions"
                                                        body={(rowData) => (
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-pencil"
                                                                    className="p-button-rounded p-button-text p-button-info"
                                                                    tooltip="Edit"
                                                                    onClick={() => handleEdit(rowData)}
                                                                />
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="p-button-rounded p-button-text p-button-danger"
                                                                    tooltip="Delete"
                                                                    type="button"
                                                                    onClick={() => handleDelete(rowData.id)}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>

                                                {/* Button in next row, aligned right */}
                                                
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>


                        </Col>


                        {/* 2nd Row */}

                        <Col xl={6}>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Company Details</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Industry</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="card mb-0">
                                                            {/* <Dropdown
                                                                id="industry"
                                                                value={industry}
                                                                onChange={e => setIndustry(e.value)}
                                                                options={dynamicIndustries.length > 0 ? dynamicIndustries : industries}
                                                                optionLabel="name"
                                                                filter
                                                                filterPlaceholder="Search Industry"
                                                                className="w-full activejobdrop"
                                                                placeholder={getIndustryDisplayName()}
                                                            /> */}
                                                            <Dropdown
                                                                id="industry"
                                                                value={industry}
                                                                onChange={e => {
                                                                    setIndustry(e.value)
                                                                    const val = e.value
                                                                    if (val && val.id && val.id !== 'add' && val.id !== 'edit') setLastSelectedIndustryId(val)
                                                                }}
                                                                options={[...dynamicIndustries, { id: 'add', name: 'Add New', icon: 'pi pi-plus' }, ...(industry ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : [])]}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                filterPlaceholder="Search Industry"
                                                                className="w-full activejobdrop"
                                                                placeholder="Search Industry"
                                                                itemTemplate={(option) => (
                                                                    <div className="flex align-items-center gap-2">
                                                                        {option && option.icon && <i className={option.icon} />}
                                                                        <span>{option && (option.name || option.value)}</span>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="companySize">Company Size</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="card mb-0">
                                                            <Dropdown
                                                                id="companySize"
                                                                value={companySize}
                                                                onChange={e => setCompanySize(e.value)}
                                                                options={dynamicCompanySizes.length > 0 ? dynamicCompanySizes : companySizes}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                filterPlaceholder="Search Company Size"
                                                                className="w-full activejobdrop"
                                                                placeholder="Search Company Size"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="overview">Overview</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="p-field mb-0">
                                                            <InputTextarea
                                                                autoResize
                                                                rows={4}
                                                                cols={30}
                                                                placeholder="Enter a description..."
                                                                value={overview1}
                                                                onChange={(e) => setOverview1(e.target.value)}
                                                                className="w-full"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="currentSalary" className="block mb-2">
                                                            Categories
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="category"
                                                            value={selectedCategory1}
                                                            onChange={(e) => setSelectedCategory1(e.value)}
                                                            options={dynamicCategories.length > 0 ? dynamicCategories : categoryOptions}
                                                            placeholder={getCategoryDisplayName()}
                                                            className="w-full bgclr"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="yearFounded" className="block mb-2">
                                                            Groups
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="group"
                                                            value={selectedGroup1}
                                                            onChange={(e) => setSelectedGroup1(e.value)}
                                                            options={dynamicGroups.length > 0 ? dynamicGroups : groupOptions}
                                                            placeholder={getGroupDisplayName()}
                                                            className="w-full bgclr"
                                                            optionValue="id"
                                                        />
                                                    </Col>
                                                </Row>

                                               


                                                {/* <Row className="mt-2 align-items-center mb-2">
                                                    <Col xl={3}>
                                                        <label htmlFor="attachment">Attach Document</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <DataTable
                                                            value={documents}
                                                            rows={5}
                                                            className="p-datatable-gridlines"
                                                            emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                        >
                                                            <Column
                                                                field="description"
                                                                header="Subject"
                                                            />
                                                            <Column
                                                                field="created_at"
                                                                header="Uploaded On"
                                                                body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                            />
                                                            <Column
                                                                header="Attachment"
                                                                body={(rowData) => rowData.file ? (
                                                                    <a href={rowData.file} target="_blank" rel="noopener noreferrer">
                                                                        View File
                                                                    </a>
                                                                ) : 'No file'}
                                                            />
                                                        </DataTable>
                                                        <Button
                                                            label="Add Document"
                                                            icon="pi pi-plus"
                                                        />
                                                    </Col>
                                                </Row> */}

                                                <Row className="mb-2 mt-2">
                                                    <Col lg={3}>
                                                        <label htmlFor="address">Address</label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <div
                                                            className="p-field companie-add"
                                                            style={{ position: "relative" }}
                                                        >
                                                            <InputTextarea
                                                                id="address"
                                                                value={address}
                                                                onChange={e => setAddress(e.target.value)}
                                                                placeholder="Enter your address"
                                                                style={{ paddingRight: "2rem" }} // Optional styling
                                                                rows={8} // Specify number of rows
                                                                cols={30} // Specify width
                                                                className="w-full"
                                                            />
                                                            {/* Edit Icon */}
                                                            <i
                                                                className="pi pi-pencil"
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    top: "70%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#6c757d",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => setVisible(true)}
                                                            ></i>
                                                        </div>
                                                    </Col>



                                                    <Dialog
                                                        header="Edit Address"
                                                        className="address-popup"
                                                        visible={visible}
                                                        onHide={() => {
                                                            setVisible(false);
                                                            setStreet1('');
                                                            setStreet2('');
                                                            setSelectedCity(null);
                                                            setSelectedState(null);
                                                            setSelectedCountry(null);
                                                            setPostalCode('');
                                                            setSelectedLabel(null);
                                                            setAddress('');
                                                        }}
                                                        style={{ width: "30vw" }}
                                                        breakpoints={{
                                                            "960px": "75vw",
                                                            "641px": "100vw",
                                                        }}
                                                    >
                                                        <div className="card sidebardetails">
                                                            <form>
                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <div className="p-field">
                                                                            <label htmlFor="street1">
                                                                                Street 1
                                                                            </label>
                                                                            <InputText
                                                                                id="street1"
                                                                                value={street1}
                                                                                onChange={e => {
                                                                                    setStreet1(e.target.value)
                                                                                    updateAddress()
                                                                                }}
                                                                                placeholder=""
                                                                                className="w-full activejobdrop"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="street2">Street 2</label>
                                                                        <InputText
                                                                            id="street2"
                                                                            value={street2}
                                                                            onChange={e => {
                                                                                setStreet2(e.target.value)
                                                                                updateAddress()
                                                                            }}
                                                                            placeholder="Enter Street 2 (Optional)"
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <label htmlFor="city">City</label>
                                                                        <Dropdown
                                                                            id="city"
                                                                            value={selectedCity}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedCity(e.value)
                                                                            }}
                                                                            options={addCities}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search City"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="City Name"
                                                                        />
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="state">State</label>
                                                                        <Dropdown
                                                                            id="state"
                                                                            value={selectedState}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedState(e.value)
                                                                            }}
                                                                            options={addStates}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search State"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="State Name"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <label htmlFor="country">Country</label>
                                                                        <Dropdown
                                                                            id="country"
                                                                            value={selectedCountry}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedCountry(e.value)
                                                                            }}
                                                                            options={addCountries}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search Country"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="Country Name"
                                                                        />
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="postalCode">
                                                                           Zip Code
                                                                        </label>
                                                                        <InputText
                                                                            id="postalCode"
                                                                            value={postalCode}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setPostalCode(e.target.value)
                                                                            }}
                                                                            placeholder="Postal Code"
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={12}>
                                                                        <label htmlFor="postalCode">Label</label>
                                                                        <Dropdown
                                                                            value={selectedLabel}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedLabel(e.value)
                                                                            }}
                                                                            options={labels}
                                                                            optionLabel="name"
                                                                            placeholder="Work From Office"
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Button
                                                                            type="button"
                                                                            color="primary"
                                                                            className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                                                                            onClick={() => { setVisible(false); }}
                                                                        >
                                                                            <i className="pi pi-check me-1"></i> Save
                                                                        </Button>

                                                                        <Button
                                                                            type="button"
                                                                            color="primary"
                                                                            className="btn btn-primary waves-effect waves-light cancelbtn me-2"
                                                                            onClick={() => {
                                                                                setVisible(false);
                                                                                setStreet1('');
                                                                                setStreet2('');
                                                                                setSelectedCity(null);
                                                                                setSelectedState(null);
                                                                                setSelectedCountry(null);
                                                                                setPostalCode('');
                                                                                setSelectedLabel(null);
                                                                                setAddress('');
                                                                            }}
                                                                        >
                                                                            <i className="pi pi-times me-1"></i>
                                                                            Cancel
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </form>
                                                        </div>
                                                    </Dialog>


                                                </Row>

                                                  <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <div className="p-field d-flex align-items-center">
                                                            
                                                            <label htmlFor="privateCheckbox" className="ms-2">Private</label>
                                                        </div>
                                                    </Col>
                                                    <Col xl={1}>
                                                        <div className="p-field d-flex align-items-center">
                                                            <Checkbox
                                                                inputId="privateCheckbox"
                                                                checked={privateDrop}
                                                                onChange={(e) => setPrivateDrop(e.checked)}
                                                            />
                                                           
                                                        </div>
                                                    </Col>
                                                    <Col xl={8}>
                                                        {privateDrop && (
                                                            <div className="p-field">
                                                                {/* <label htmlFor="userIds">User Id's</label> */}
                                                                <MultiSelect
                                                                    value={PrivetDropdown}
                                                                    onChange={(e) => setPrivetDropdown(e.value)}
                                                                    options={PrivetDropdownValues}
                                                                    optionLabel={(option) => `${option.name} (${option.email})`}
                                                                    display="comma"
                                                                    placeholder="Select User Id's"
                                                                    maxSelectedLabels={8}
                                                                    className="w-full"
                                                                />
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>

                                                

                                            </div>

                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                          

                              <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Social Pages</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">
                                                <Row>
                                                    <Col xl={12}>
                                                        <Row className="align-items-center mt-2">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    LinkedIn URL
                                                                </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="linkedin-url"
                                                                    value={linkedinUrl}
                                                                    onChange={(e) => setLinkedinUrl(e.target.value)}
                                                                    className="w-full"
                                                                    style={{ position: "relative" }}
                                                                    placeholder="Enter LinkedIn URL"
                                                                />
                                                                <i
                                                                    className="pi pi-linkedin linkd-icon"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "26px",
                                                                        top: "34%",
                                                                        transform: "translateY(-50%)",
                                                                        // cursor: "pointer"
                                                                    }}
                                                                ></i>
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <label

                                                                    className=" block"
                                                                >
                                                                    Facebook URL
                                                                </label>

                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="facebook-url"
                                                                    value={facebookUrl}
                                                                    onChange={(e) => setFacebookUrl(e.target.value)}
                                                                    className="w-full"
                                                                    style={{ position: "relative" }}
                                                                    placeholder="Enter Facebook URL"
                                                                />
                                                                <i
                                                                    className="pi pi-facebook facebook-icon"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "26px",
                                                                        top: "51%",
                                                                        transform: "translateY(-50%)",
                                                                        // cursor: "pointer"
                                                                    }}
                                                                ></i>
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                                <div className="d-flex align-items-start">
                                                                    {/* <div>
                                                            <i className="pi pi-twitter me-1 twitter-icon"></i>
                                                          </div> */}

                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Twitter URL
                                                                    </label>
                                                                </div>

                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="twitter-url"
                                                                    value={twitterUrl}
                                                                    onChange={(e) => setTwitterUrl(e.target.value)}
                                                                    className="w-full"
                                                                    style={{ position: "relative" }}
                                                                    placeholder="Enter Twitter URL"
                                                                />
                                                                <i
                                                                    className="pi pi-twitter twitter-icon"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "26px",
                                                                        top: "69%",
                                                                        transform: "translateY(-50%)",
                                                                        // cursor: "pointer"
                                                                    }}
                                                                ></i>
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>

                                                                <div className="d-flex align-items-start">
                                                                    {/* <div>
                                                            <i className="pi pi-info me-1 indeed-icon"></i>
                                                          </div> */}
                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Indeed URL
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                            <Col xl={9}>
                                                                <InputText
                                                                    id="indeed-url"
                                                                    value={indeedUrl}
                                                                    onChange={(e) => setIndeedUrl(e.target.value)}
                                                                    className="w-full"
                                                                    placeholder="Enter Indeed URL"
                                                                />
                                                                <i
                                                                    className="pi pi-info me-1 indeed-icon"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "22px",
                                                                        top: "86%",
                                                                        transform: "translateY(-50%)",
                                                                        // cursor: "pointer"
                                                                    }}
                                                                ></i>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row >

                   

                    <Row className="align-items-center mb-3">
                        <Col md={12}>
                            <div className="d-flex justify-content-end">
                                <button 
                                    type="button" 
                                    className="btn btn-success me-2"
                                    onClick={handleUpdateCompany}
                                    disabled={isLoading}
                                >
                                    <i className="pi pi-save me-1"></i>
                                    {isLoading ? 'Saving...' : (companyData ? 'Update' : 'Save')}
                                </button>

                                <Link to="/companies-allactive">
                                    <Button
                                        color="primary"
                                        className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                        onClick={showCancel}
                                    >
                                        <i className="pi pi-times me-1"></i>
                                        Cancel
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container >
                <Dialog
                    header={editingStatus ? "Edit Industry" : "Add Industry"}
                    visible={statusModalVisible}
                    style={{ width: "400px" }}
                    modal
                    onHide={() => {
                        setStatusModalVisible(false);
                        setEditingStatus(false);
                        setStatusForm("");
                        setStatusDescription("");
                    }}
                >
                    <div className="p-fluid">
                        {editingStatus && (
                            <>
                                <label className="mb-1">Select Industry to edit</label>
                                <Dropdown
                                    value={industry}
                                    options={dynamicIndustries}
                                    onChange={(e) => {
                                        const selectedObj = dynamicIndustries.find(
                                            (opt) => opt.id === e.value || opt.code === e.value
                                        );
                                        setStatusForm(selectedObj ? selectedObj.name || selectedObj.value : "");
                                        setIndustry(e.value);
                                    }}
                                    placeholder="Select to prefill"
                                    className="w-full bgclr mb-2"
                                    optionLabel="name"
                                    optionValue="id"
                                    filter
                                />
                            </>
                        )}

                        <div className="p-field mb-3">
                            <label htmlFor="lookupValue">Value</label>
                            <span className="text-danger ms-2">*</span>
                            <InputText
                                id="lookupValue"
                                value={statusForm}
                                onChange={(e) => setStatusForm(e.target.value)}
                                placeholder="Enter value"
                            />
                        </div>

                        <div className="p-field mb-3">
                            <label htmlFor="lookupDescription">Description</label>
                            <InputTextarea
                                id="lookupDescription"
                                value={statusDescription}
                                onChange={(e) => setStatusDescription(e.target.value)}
                                rows={3}
                                placeholder="Enter description (optional)"
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-text me-2"
                            onClick={() => {
                                setStatusModalVisible(false);
                                setEditingStatus(false);
                                setStatusForm("");
                                setStatusDescription("");
                            }}
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            className="p-button-primary"
                            onClick={() => handleLookupSave()}
                        />
                    </div>
                </Dialog>
                <Dialog
                    header="Add Document"
                    visible={displayDialog}
                    onHide={() => {{setDisplayDialog(false);setSelectedDocument(null); setSubject('');setUploadedFiles([])}}}
                    style={{ width: "30vw" }}
                    footer={
                        <div className="d-flex justify-content-end gap-2">
                            {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                                <i className="pi pi-pencil me-1"></i>
                                Update
                            </Button> :
                                <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                                    <i className="pi pi-plus me-1"></i>
                                    Add Document
                                </Button>}
                            <Button color="btn btn-primary cancel-outlinebtn" onClick={() => {{setDisplayDialog(false);setSelectedDocument(null); setSubject('');setUploadedFiles([])}}}>
                                <i className="pi pi-times me-1"></i>
                                Cancel
                            </Button>
                        </div>
                    }
                >
                    <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                            <label htmlFor="documentType" className="block mb-2">
                                Document Type
                            </label>
                        </Col>
                        <Col xl={9}>
                            <Dropdown
                                id="documentType"
                                value={selectedDocument}
                                onChange={(e) => setSelectedDocument(e.value)}
                                options={[
                                    ...documentTypes,
                                    { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                    ...(selectedDocument ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                ]}
                                optionLabel="name"
                                optionValue="code"
                                className="w-full bgclr"
                                style={{ border: '1px solid #ced4da' }}
                                placeholder="Select Document Type"
                                itemTemplate={(option) => (
                                    <div className="flex align-items-center gap-2">
                                        {option?.icon && <i className={option.icon}></i>}
                                        <span>{option.name || option.value}</span>
                                    </div>
                                )}
                            />
                        </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                            <label htmlFor="documentSubject" className="block mb-2">
                                Document Subject
                            </label>
                        </Col>
                        <Col xl={9}>
                            <InputText
                                id="documentSubject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="w-full"
                                style={{ border: '1px solid #ced4da' }}
                                placeholder="Enter document subject or description"
                            />
                        </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                            <label htmlFor="documentAttachment" className="block mb-2">
                                File Attachment
                            </label>
                        </Col>
                        <Col xl={9}>
                            <FileUpload
                                ref={fileUploadRef}
                                name="files[]"
                                accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                maxFileSize={5242880}
                                multiple
                                customUpload
                                auto={false}
                                onSelect={(e) => {
                                    const currentFiles = uploadedFiles || [];
                                    const newFiles = e.files || [];

                                    // Calculate total size including existing files
                                    const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                                    const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                                    const totalSize = currentTotalSize + newTotalSize;

                                    // Check total size limit (5MB = 5,242,880 bytes)
                                    if (totalSize > 5242880) {
                                        toast.current?.show({
                                            severity: 'error',
                                            summary: 'File Size Error',
                                            detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB`
                                        });

                                        // Clear the new selection but preserve existing files
                                        if (fileUploadRef.current) {
                                            fileUploadRef.current.clear();
                                            if (currentFiles.length > 0) {
                                                fileUploadRef.current.setFiles(currentFiles);
                                            }
                                        }
                                        return;
                                    }

                                    // Check file types
                                    const allowedTypes = [
                                        'image/jpeg', 'image/jpg', 'image/png',
                                        'application/pdf',
                                        'application/msword',
                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                        'text/plain',
                                        'application/vnd.ms-excel',
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                    ];

                                    const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                                    if (invalidFiles.length > 0) {
                                        toast.current?.show({
                                            severity: 'error',
                                            summary: 'Invalid File Type',
                                            detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`
                                        });

                                        // Clear the new selection but preserve existing files
                                        if (fileUploadRef.current) {
                                            fileUploadRef.current.clear();
                                            if (currentFiles.length > 0) {
                                                fileUploadRef.current.setFiles(currentFiles);
                                            }
                                        }
                                        return;
                                    }

                                    // All validations passed, update the files
                                    const combinedFiles = [...currentFiles, ...newFiles];
                                    setUploadedFiles(combinedFiles);
                                }}
                                uploadHandler={(e) => {
                                    console.log("Upload handler called", e.files);
                                }}
                                onClear={() => {
                                    console.log("Files cleared");
                                    setUploadedFiles([]);
                                }}
                            />
                            <small className="text-muted">
                                Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                            </small>
                        </Col>
                    </Row>
                    {FileNames && FileNames.length > 0 && (
                        <Row className="mt-2 align-items-center">
                            <Col xl={3}>
                                <label className="block mb-2">Previously Attached Files</label>
                            </Col>
                            <Col xl={9}>
                                {FileNames.map((file) => (
                                    <div key={file.id} className="d-flex align-items-center mb-2">
                                        <a
                                            href={file.url || file.name} // use URL if available
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="me-2"
                                        >
                                            {file.name.split('/').pop()}
                                        </a>
                                        <i
                                            className="pi pi-times"
                                            style={{ cursor: "pointer", color: "red" }}
                                            onClick={() => {
                                                // Remove the clicked file from FileNames
                                                setFileNames(prev => prev.filter(f => f.id !== file.id));
                                            }}
                                        ></i>
                                    </div>
                                ))}
                            </Col>

                        </Row>
                    )}
                </Dialog>
            </div >
        </React.Fragment >
    )
}

export default CompanyEditForm;
